module.exports = __webpack_public_path__ + "static/media/twitter.b80ee9c3.png";